import State from '../core/State';
import { SalesByCategorySummaryData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingSalesByCategorySummaries = () =>
  produce((draft: Draft<State>) => {
    draft.productsSummary.fetching = draft.productsSummary.fetching + 1;
  });

export const setSalesByCategorySummaries = (summaryData: SalesByCategorySummaryData[]) =>
  produce((draft: Draft<State>) => {
    draft.productsSummary.data = summaryData;
  });

export const finishFetchingSalesByCategorySummaries = () =>
  produce((draft: Draft<State>) => {
    draft.productsSummary.fetching = draft.productsSummary.fetching - 1;
  });

export const disposeSalesByCategorySummaries = () =>
  produce((draft: Draft<State>) => {
    draft.productsSummary.data = initialState.productsSummary.data;
    draft.productsSummary.fetching = initialState.productsSummary.fetching;
  });
